import { useState } from 'react'

const useVersion = (defaultVersion = 'v1') => {
  const [version, setVersion] = useState(defaultVersion)

  return {
    version,
    setVersion: (newVersion) => {
      localStorage.setItem('version', newVersion)
      setVersion(newVersion)
    }
  }
}

export default useVersion
